module.exports = __webpack_public_path__ + "img/i-roles-3.37da0a79.png";